import { merge } from 'lodash';

export function materialOption(op) {
  return merge(
    {},
    {
      color: '#00CBC7',
      textStyle: {
        color: '#B1FFFC'
      },
      dataZoom: [{ type: 'inside' }],
      grid: {
        show: true,
        borderWidth: 0,
        top: '15%',
        bottom: '10%',
        backgroundColor: 'rgba(18, 30, 44, .8)'
      },
      title: {
        left: '10%',
        top: '5%',
        textStyle: {
          color: '#fff'
        }
      },
      xAxis: {
        type: 'category'
      },
      yAxis: {
        type: 'value',
        axisLine: {
          show: false
        },
        splitLine: {
          lineStyle: { color: '#3b454f' }
        },
        max(v) {
          return v.max * 2;
        }
      },
      tooltip: {
        trigger: 'axis',
        confine: true
      },
      series: [
        {
          type: 'line',
          data: [],
          showSymbol: false,
          smooth: true,
          itemStyle: {
            borderColor: '#fff',
            borderWidth: '2'
          },
          lineStyle: {
            width: 1,
            shadowColor: '#fff',
            shadowBlur: 1,
            color: {
              type: 'linear',
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                { offset: 0, color: '#1F8797' },
                { offset: 0.33, color: '#76F2F1' },
                { offset: 0.66, color: '#4277DB' },
                { offset: 1, color: '#6952F7' }
              ]
            }
          }
        }
      ]
    },
    op
  );
}
